import React, { useState, useEffect } from 'react'
import { getRolesWithPage } from "../../services/serviceRole";
import { Button, Card, Table } from "antd";
import RoleActions from "./RoleActions";
import RoleCreate from "./RoleCreate";

const Role = () => {
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getRoles(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getRoles = (page, pageSize) => {
        getRolesWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getRoles(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    roleName: item.name,
                    roleCode: item.code
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const columns = [
        {
            title: 'Adı',
            dataIndex: 'roleName',
            key: 'roleName'
        },
        {
            title: 'Kodu',
            dataIndex: 'roleCode',
            key: 'roleCode'
        },
        {
            title: 'Actions',
            key: 'action',
            render: (text, record) => <RoleActions record={record} updater={handlers.updater} />
        }
    ];

    return (
        <React.Fragment>
            <Card title={'Rol listesi'} extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'} >Yeni Ekle</Button>}>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <RoleCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}
        </React.Fragment>
    )
}
export default Role